import { render, staticRenderFns } from "./warehouseStorage.vue?vue&type=template&id=77600c80&"
import script from "./warehouseStorage.vue?vue&type=script&lang=js&"
export * from "./warehouseStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports